@let data = freeTrialData();
@let nameCtrl = demoForm.controls.name;
@let surnameCtrl = demoForm.controls.surname;
@let emailCtrl = demoForm.controls.email;
@let compCtrl = demoForm.controls.company;

@if (isDialog()) {
  <div class="pyg-dialog-bg">
    <div class="pyg-dialog-form" (clickOutside)="onCloseDialog()">
      <ng-template [ngTemplateOutlet]="formTemp"></ng-template>
    </div>
  </div>
} @else if (status() !== "success") {
  <h2>{{ data.title | translate }}</h2>
  @if (data.subtitle) {
    <p class="pyg-subtitle">{{ data.subtitle | translate }}</p>
  }
  <p class="py-4 sm:pb-8 pyg-get-questions">
    {{ "freetrial.get_questions" | translate }}
  </p>
  <form [formGroup]="demoForm" (clickOutside)="outsideForm()">
    <label>{{ "freetrial.name" | translate }}</label>
    <input
      type="text"
      formControlName="name"
      autocomplete="given-name"
      [class.pyg-danger]="nameCtrl.invalid && nameCtrl.touched"
    />
    @if (nameCtrl.invalid && nameCtrl.touched) {
      <p class="pygMessage">
        {{ "freetrial.name_warn" | translate }}
      </p>
    }
    <label>{{ "freetrial.lastname" | translate }}</label>
    <input
      type="text"
      formControlName="surname"
      autocomplete="family-name"
      [class.pyg-danger]="surnameCtrl.invalid && surnameCtrl.touched"
    />
    @if (surnameCtrl.invalid && surnameCtrl.touched) {
      <p class="pygMessage">
        {{ "freetrial.lastname_warn" | translate }}
      </p>
    }
    <label>{{ "freetrial.email_bussines" | translate }}</label>
    <input
      type="email"
      formControlName="email"
      autocomplete="email"
      placeholder="@"
      [class.pyg-danger]="emailCtrl.invalid && emailCtrl.touched"
    />
    @if (emailCtrl.invalid && emailCtrl.touched) {
      <p class="pygMessage">
        @if (emailCtrl.errors?.["email"]) {
          {{ "subscribe.email_invalid" | translate }}
        }
        @if (emailCtrl.errors?.["required"]) {
          {{ "freetrial.email_warn" | translate }}
        }
        @if (emailCtrl.errors?.["unwantedDomain"]) {
          {{ "freetrial.email_warn_bussines" | translate }}
        }
      </p>
    }
    <label>{{ "freetrial.company" | translate }}</label>
    <input
      type="text"
      formControlName="company"
      autocomplete="organization"
      [class.pyg-danger]="compCtrl.invalid && compCtrl.touched"
    />
    @if (compCtrl.invalid && compCtrl.touched) {
      <p class="pygMessage">
        {{ "freetrial.company_warn" | translate }}
      </p>
    }
    <div class="mt-6">
      @if (status() === "error") {
        <p class="text-red-600 text-base text-center pb-2">
          {{ "freetrial.warn" | translate }}
        </p>
      }
      <button
        class="mx-auto z-10 font-bold rounded-l-full rounded-r-full block w-full h-12"
        (click)="sendRequest()"
        [disabled]="status() === 'pending'"
      >
        {{ data.button ?? "buttons.contact_us" | translate }}
      </button>
    </div>
    <small
      >{{ "freetrial.handle_request" | translate }}
      <a langRouterLink="privacy-policy">{{
        "freetrial.privacy_policy" | translate
      }}</a>
    </small>
  </form>
} @else {
  <div class="flex justify-center flex-col text-center">
    <img
      class="mx-auto w-20"
      src="assets/img/Shared/check-circle-purple.svg"
      alt="check"
    />
    <h1 class="pt-6">{{ "success.thank_you" | translate }}</h1>
    <p class="pt-8">
      {{ "success.request_success" | translate }}
    </p>
    <p class="pt-3.5">
      {{ "success.give_call" | translate }}
      <b
        ><a [attr.href]="'tel:' + tel()">{{ tel() }}</a></b
      >.
    </p>
  </div>
}

<ng-template #formTemp>
  @if (status() !== "success") {
    <h2>{{ data.title | translate }}</h2>
    @if (data.subtitle) {
      <p class="pyg-subtitle">{{ data.subtitle | translate }}</p>
    }
    <p class="py-4 sm:pb-8 pyg-get-questions">
      {{ "freetrial.get_questions" | translate }}
    </p>
    <form [formGroup]="demoForm" (clickOutside)="outsideForm()">
      <label>{{ "freetrial.name" | translate }}</label>
      <input
        type="text"
        formControlName="name"
        autocomplete="given-name"
        [class.pyg-danger]="nameCtrl.invalid && nameCtrl.touched"
      />
      @if (nameCtrl.invalid && nameCtrl.touched) {
        <p class="pygMessage">
          {{ "freetrial.name_warn" | translate }}
        </p>
      }
      <label>{{ "freetrial.lastname" | translate }}</label>
      <input
        type="text"
        formControlName="surname"
        autocomplete="family-name"
        [class.pyg-danger]="surnameCtrl.invalid && surnameCtrl.touched"
      />
      @if (surnameCtrl.invalid && surnameCtrl.touched) {
        <p class="pygMessage">
          {{ "freetrial.lastname_warn" | translate }}
        </p>
      }
      <label>{{ "freetrial.email_bussines" | translate }}</label>
      <input
        type="email"
        formControlName="email"
        autocomplete="email"
        placeholder="@"
        [class.pyg-danger]="emailCtrl.invalid && emailCtrl.touched"
      />
      @if (
        emailCtrl.invalid && emailCtrl.errors?.["required"] && emailCtrl.touched
      ) {
        <p class="pygMessage">
          {{ "freetrial.email_warn" | translate }}
        </p>
      }
      @if (
        emailCtrl.invalid &&
        emailCtrl.errors?.["unwantedDomain"] &&
        emailCtrl.touched
      ) {
        <p class="pygMessage">
          {{ "freetrial.email_warn_bussines" | translate }}
        </p>
      }
      <label>{{ "freetrial.company" | translate }}</label>
      <input
        type="text"
        formControlName="company"
        autocomplete="organization"
        [class.pyg-danger]="compCtrl.invalid && compCtrl.touched"
      />
      @if (compCtrl.invalid && compCtrl.touched) {
        <p class="pygMessage">
          {{ "freetrial.company_warn" | translate }}
        </p>
      }
      <div class="mt-6">
        @if (status() === "error") {
          <p class="text-red-600 text-base text-center pb-2">
            {{ "freetrial.warn" | translate }}
          </p>
        }
        <button
          class="mx-auto z-10 font-bold rounded-l-full rounded-r-full block w-full h-12"
          (click)="sendRequest()"
          [disabled]="status() === 'pending'"
        >
          {{ data.button ?? "buttons.contact_us" | translate }}
        </button>
      </div>
      <small
        >{{ "freetrial.handle_request" | translate }}
        <a langRouterLink="privacy-policy">{{
          "freetrial.privacy_policy" | translate
        }}</a>
      </small>
    </form>
  } @else {
    <div class="flex justify-center flex-col text-center">
      <img
        class="mx-auto w-20"
        src="assets/img/Shared/check-circle-purple.svg"
        alt="check"
      />
      <h1 class="pt-6">{{ "success.thank_you" | translate }}</h1>
      <p class="pt-8">
        {{ "success.request_success" | translate }}
      </p>
      <p class="pt-3.5">
        {{ "success.give_call" | translate }}
        <b
          ><a [attr.href]="'tel:' + tel()">{{ tel() }}</a></b
        >.
      </p>
    </div>
  }
</ng-template>
